/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Providers, helper } from '@tripian/model';
import { DatePicker, Dropdown, NumberCounter, Button, RatingStars, PreLoading } from '@tripian/react';

import './GygTourInfoForm.scss';

const useDates = (tourDate: moment.Moment) => ({
  startDate: tourDate.hours(0).format('YYYY-MM-DDTHH:mm:ss'),
  endDate: tourDate.clone().add(7, 'd').hours(23).minute(59).format('YYYY-MM-DDTHH:mm:ss'),
});

interface IGygTourInfoForm {
  tour: Providers.Gyg.Tour;
  date: moment.Moment;
  adult: number;
  child: number;
  test: boolean;

  apiTourAvailabilities: (tourId: number, startDate: string, endDate?: string, language?: string, currency?: string) => Promise<Providers.Gyg.TourAvailability[]>;
  apiOptions: (tourId: number, language?: string, currency?: string) => Promise<Providers.Gyg.TourOption[]>;
  apiOptionPricings: (optionId: number, language?: string, currency?: string) => Promise<Providers.Gyg.TourOptionPricing>;
  apiOptionAvailabilities: (optionId: number, startDate: string, endDate?: string | undefined, language?: string | undefined, currency?: string | undefined) => Promise<Providers.Gyg.TourAvailability[]>;
  apiBookingAdd: (tourBookingRequest: Providers.Gyg.TourBookingRequest) => Promise<Providers.Gyg.TourBooking>;
  apiPaymentConfiguration: (language?: string, currency?: string, country?: string) => Promise<Providers.Gyg.PaymentConfiguration[]>;
  apiCartAdd: (tourBookingCartRequest: Providers.Gyg.TourBookingCartRequest) => Promise<Providers.Gyg.TourBookingCart>;
}

const GygTourInfoForm: React.FC<IGygTourInfoForm> = ({
  tour,
  date,
  adult,
  child,
  test,

  apiTourAvailabilities,
  apiOptions,
  apiOptionPricings,
  apiOptionAvailabilities,
  apiBookingAdd,
  apiPaymentConfiguration,
  apiCartAdd,
}) => {
  const [tourDate, setTourDate] = useState<moment.Moment>(date);

  const [tourOptions, setTourOptions] = useState<Providers.Gyg.TourOption[] | undefined>(undefined);
  const [selectedTourOptionId, setSelectedTourOptionId] = useState<number | undefined>(undefined);

  const [optionAvailabilities, setOptionAvailabilities] = useState<Providers.Gyg.TourAvailability[] | undefined>(undefined);
  const [selectedAvailability, setSelectedAvailability] = useState<Providers.Gyg.TourAvailability | undefined>(undefined);

  const [optionAvailabilityPricings, setOptionAvailabilityPricings] = useState<Providers.Gyg.TourOptionPricing | undefined>(undefined);

  // const [tourAvailabilities, setTourAvailabilities] = useState<Providers.Gyg.TourAvailability[] | undefined>(undefined);

  const dates = useDates(tourDate);

  const onChangeTourDate = (newDate: moment.Moment | null) => {
    setTourDate(newDate || date);
  };

  // useEffect(() => {
  //   setTourAvailabilities(undefined);
  //   apiTourAvailabilities(tour.tour_id, dates.startDate, dates.endDate).then((as) => {
  //     setTourAvailabilities(as);
  //   });
  //   return () => {};
  // }, [apiTourAvailabilities, dates.endDate, dates.startDate, tour.tour_id]);

  useEffect(() => {
    setTourOptions(undefined);
    apiOptions(tour.tour_id).then((os) => {
      setTourOptions(os);
    });
    return () => {};
  }, [apiOptionAvailabilities, apiOptions, tour.tour_id]);

  useEffect(() => {
    setSelectedAvailability(undefined);
    setOptionAvailabilities(undefined);
    if (selectedTourOptionId) {
      apiOptionAvailabilities(selectedTourOptionId, dates.startDate, dates.endDate).then((oas) => {
        setOptionAvailabilities(oas);
      });
    }
    return () => {};
  }, [selectedTourOptionId, dates.startDate, dates.endDate, apiOptionAvailabilities]);

  useEffect(() => {
    setOptionAvailabilityPricings(undefined);
    if (selectedAvailability && selectedTourOptionId) {
      apiOptionPricings(selectedTourOptionId).then((ops) => {
        setOptionAvailabilityPricings(ops);
      });
    }
    return () => {};
  }, [selectedAvailability, apiOptionPricings, selectedTourOptionId]);

  const aRender = (a: Providers.Gyg.TourAvailability) => (
    <>
      <span>Price Id: {a.pricing_id}</span>
      <br />
      <span>Discount: {a.discount}</span>
      <br />
      <span>Vacancies: {a.vacancies}</span>
      <br />
      <span>
        Date: {a.start_time}-{a.end_time}
      </span>
    </>
  );

  // const availabilitiesRender = () => {
  //   if (tourAvailabilities) {
  //     if (tourAvailabilities.length === 0) return <span>Tour is not availabile on this week. Please change date.</span>;

  //     return (
  //       <>
  //         {tourAvailabilities.map((a) => (
  //           <li style={{ border: 1, borderStyle: 'solid', borderColor: 'blue', borderRadius: 10 }}>
  //             <div className="gygTourInfoButton">{aRender(a)}</div>
  //           </li>
  //         ))}
  //       </>
  //     );
  //   }

  //   return <PreLoading />;
  // };

  const optionAvailabilitiesRender = () => {
    if (optionAvailabilities) {
      if (optionAvailabilities.length === 0) return <span>This option avalibilities is empty. Please try other options.</span>;

      return (
        <>
          {optionAvailabilities
            .filter((oa0) => selectedAvailability === undefined || selectedAvailability.start_time === oa0.start_time)
            .map((oa) => (
              <li style={{ border: 1, borderStyle: 'solid', borderColor: 'red', borderRadius: 10 }}>
                {aRender(oa)}
                <br />
                <button
                  type="button"
                  onClick={() => {
                    setSelectedAvailability(oa);
                  }}
                >
                  Select Price
                </button>
              </li>
            ))}
        </>
      );
    }

    return <PreLoading />;
  };

  const optionsRender = () => {
    if (tourOptions) {
      if (tourOptions.length === 0) return <span>This tour has not a option. Please try other tours.</span>;

      return (
        <>
          {tourOptions.map((o) => (
            <li style={{ border: 1, borderStyle: 'solid', borderColor: 'blue', borderRadius: 10 }}>
              <div className="gygTourInfoButton">
                <h2>{o.title}</h2>
                <span>Option Id: {o.option_id}</span>
                <br />
                <span>Price: {JSON.stringify(o.price)}</span>
                <br />
                {o.booking_parameter.length > 0 ? (
                  <>
                    <br />
                    <h4>Booking Parameters</h4>
                    {o.booking_parameter.map((bp) => (
                      <span>
                        <b>{bp.name}:</b> {bp.mandatory ? 'mandatory' : 'optional'}
                        <br />
                      </span>
                    ))}
                  </>
                ) : null}
              </div>
              <button
                type="button"
                onClick={() => {
                  setSelectedTourOptionId(o.option_id);
                  setSelectedAvailability(undefined);
                }}
              >
                Select Option
              </button>
            </li>
          ))}
        </>
      );
    }

    return <PreLoading />;
  };

  const pricingRender = () => {
    if (optionAvailabilityPricings) {
      return (
        <>
          {optionAvailabilityPricings.categories.map((c) => (
            <li style={{ border: 1, borderStyle: 'solid', borderColor: 'brown', borderRadius: 10 }}>
              <span>
                <b>Id:</b> {c.id}
              </span>
              {' - '}
              <span>
                <b>Name:</b> {c.name}
              </span>
              {' - '}
              <span>
                <b>Ages:</b> {c.min_age} - {c.max_age}
              </span>
              <br />
              <br />
              <div>
                <h3>Scale</h3>
                {c.scale.map((s) => (
                  <>
                    {/* <span>{s.type}</span>
                    <br /> */}
                    <span>
                      <b>Participants:</b> {s.min_participants} - {s.max_participants}
                    </span>
                    {' - '}
                    <span>
                      <b>Net Price:</b> {s.net_price}
                    </span>
                    {' - '}
                    <span>
                      <b>Retail_price Price:</b> {s.retail_price}
                    </span>
                    <br />
                  </>
                ))}
              </div>
            </li>
          ))}
        </>
      );
    }

    return <PreLoading />;
  };

  return (
    <div className="gygTourInfoForm">
      <ul>
        <li>
          <span>
            <b>Tour Options</b>
          </span>
        </li>
        {optionsRender()}
        {selectedTourOptionId ? (
          <>
            <li>
              <div className="gygTourInfoDatePicker">
                <DatePicker currentDate={tourDate} onchanged={onChangeTourDate} />
              </div>
            </li>
            {optionAvailabilitiesRender()}
          </>
        ) : null}
        {selectedAvailability ? pricingRender() : null}
        {/* <li>
          <span>
            <b>Tour Availabilities</b>
          </span>
        </li>
        {availabilitiesRender()} */}
      </ul>
    </div>
  );
};

// const timeOptions = helper.timeRange.map((t) => ({ key: undefined, value: t }));
// eslint-disable-next-line no-lone-blocks
{
  /* <li>
          <div className="gygTourInfoTimePicker">
            <Dropdown options={timeOptions} defaultValue="10:00" selectChange={() => {}} />
          </div>
        </li>
        <li>
          <div className="gygTourInfoPersonCount">
            <span className="gygTourInfoPersonCountText">Adults:</span>
            <NumberCounter defaultValue={adult} minValue={1} maxValue={10} onchange={() => {}} />
          </div>
        </li>
        <li>
          <div className="gygTourInfoPersonCount">
            <span className="gygTourInfoPersonCountText">Children:</span>
            <NumberCounter defaultValue={child} minValue={0} maxValue={10} onchange={() => {}} />
          </div>
        </li>  <li>
          <div className="gygTourInfoButton">
            <Button text="BOOK NOW" color="danger" onClick={() => {}} style={{ width: '100%' }} />
          </div>
        </li> */
}

export default GygTourInfoForm;
